/** User-facing herd tag labels (matches backend HerdTagPresentation). */

export const HERD_TAG_FAMILY_LABELS = {
  age_lifecycle: 'Age & lifecycle',
  lactation_stage: 'Lactation',
  reproduction: 'Breeding & pregnancy',
  gender: 'Sex',
  health: 'Health & treatment',
  culling: 'Cull status',
  feedlot: 'Feedlot',
  management: 'Management',
  cohort: 'Cohort',
  other: 'Other',
};

export const SPECIES_DISPLAY_LABELS = {
  cattle: 'Cattle',
  buffalo: 'Buffalo',
  sheep: 'Sheep',
  goat: 'Goat',
  camel: 'Camel',
  horse: 'Horse',
  donkey: 'Donkey',
  poultry: 'Poultry',
};

export function formatHerdTagFamily(family, familyLabelFromApi) {
  if (familyLabelFromApi) return familyLabelFromApi;
  if (!family) return HERD_TAG_FAMILY_LABELS.other;
  return HERD_TAG_FAMILY_LABELS[family] || family.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatSpeciesLabel(slug, labelFromApi) {
  if (labelFromApi) return labelFromApi;
  if (!slug || slug === '—') return null;
  return SPECIES_DISPLAY_LABELS[slug] || slug.charAt(0).toUpperCase() + slug.slice(1);
}

export function visibleSystemTags(tags) {
  return (tags || []).filter((t) => !t.is_hidden);
}

/** Tags that currently match at least one active herd animal on the farm. */
export function tagsWithAnimalsOnFarm(tags) {
  return visibleSystemTags(tags).filter((t) => Number(t.member_count ?? t.count ?? 0) > 0);
}
